// extracted by mini-css-extract-plugin
export default {"wrapper":"P_kOF1tXNl1JEdkdRYp0","formWrapper":"gNMLWW1m9mqFc9Hshvb4","resourceObjectSample":"XQtJueBMfGVXh26KsnDw"};